import React from "react";

const BS5_GetStarted = () => {
  return (
    <div className="container mt-4">
      <h2>BS5_GetStarted Component</h2>
      <p>This is the BS5_GetStarted component for Bootstrap 5 tutorial.</p>
    </div>
  );
};

export default BS5_GetStarted;
